import React, { useEffect, useState, createContext } from 'react';
import { Route, Navigate, Outlet, createBrowserRouter, createRoutesFromElements, RouterProvider, useNavigate } from 'react-router-dom';
import VerifRoute from './components/PageNotFound/VerifRoute';
import PaginaPreLogin from './components/PaginaPreLogin/PaginaPreLogin';
import NavBar from './components/NavBar/NavBar';
import MisConsultorios from './containers/MisConsutorios';
import DetailConsultorio from './components/MisConsultorios/DetailConsultorio/DetailConsultorio';
import SolicitarModificacion from './components/MisConsultorios/SolicitarModificacion.jsx/SolicitarModificacion';
import Home from './containers/Home';
import SolicitudDeConexion from './containers/SolicitudDeConexion';
import DetailSolicitudes from './components/Home/DetailSolicitudes/DetailSolicitudes';
import Sidebar from './components/NavBar/SideBar';
import Footer from './components/Home/Footer';
import VersionBar from './components/Footer/VersionBar';

function PrestadoresRoutes() {

  const [loader, setLoader] = useState(true);

  const HeaderLayout = () => {

    const navigate = useNavigate();

    useEffect(() => {
      if (window.location.pathname === '/prestador/') {
        navigate('verifyUser');
      }
    }, []);

    return (
      <>
        <header>
          <NavBar loader={loader} />
        </header>
        <main style={{ flexGrow: 1 }}>
          <Sidebar loader={loader}/>
          <Outlet />
        </main>
        <footer>
          <Footer loader={loader}/>
          <VersionBar />
        </footer>
      </>
    );

  };

  const LoaderContext = createContext();
  const LoaderProvider = ({ children }) => {
    return (
      <LoaderContext.Provider value={{ loader, setLoader }}>{children}</LoaderContext.Provider>
    );
  };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<VerifRoute loader={loader} setLoader={setLoader} />}>
        <Route path='/prestador' element={<HeaderLayout />}>
          <Route path="inicio" element={<PaginaPreLogin />} />
            <Route path="dashboard" element={<Home />} />
            <Route path="solicitud/:id" element={<DetailSolicitudes />} />
            <Route path="/prestador/misConsultorios" element={<MisConsultorios />} />
            <Route path="/prestador/misConsultorios/:consultorioId" element={<DetailConsultorio />} />
            <Route path="/prestador/misConsultorios/:consultorioId/solicitarModificacion" element={<SolicitarModificacion />} />
            <Route path="registro" element={<SolicitudDeConexion />} />
            <Route path="verifyUser" element={<Navigate to='/prestador/dashboard' />} />
          </Route>
          <Route path="*" element={<Navigate to='/prestador/dashboard' />}  />
      </Route>
    )
  );


  return (
    <LoaderProvider>
      <RouterProvider router={router} />
    </LoaderProvider>
  );
}

export default PrestadoresRoutes;
